export default {
  "title": {
    "tasks_traceability": "Rastreabilidade de desvios",
    "notifications_traceability": "Rastreabilidade de notificação"
  },
  "labels": {
    "totalTasks": "Quantidade de tarefas"
  },
  "table": {
    "occurrenceDate": "Idéia",
    "createdDate": "Criação",
    "closedDate": "Fechando",
    "type": "Tipo",
    "subtype": "Subtipo",
    "person": "Empregado",
    "vehicle": "Veículo",
    "accountable": "Responsável",
    "manager": "Gestão por",
    "state": "Estado",
    "noData": "Sem mais dados"
  },
  "tooltip": {
    "occurrenceDate": "Corresponde à data e hora exatas em que ocorreu o desvio.",
    "createdDate": "Corresponde à data em que o desvio foi criado no sistema de controle Gauss.",
    "closedDate": "Corresponde à data em que o desvio foi gerenciado.",
    "type": "Corresponde à taxa à qual o desvio se aplica. Por exemplo: Conformidade legal, distração, evento de fadiga, entre outros.",
    "subtype": "Corresponde ao subtipo ao qual o desvio se aplica. Por exemplo, se o tipo for conformidade legal, seus subtipos são: descanso diário não realizado, horas extras, entre outros.",
    "person": "Corresponde ao trabalhador que incorreu na violação ou evento que gerou o desvio.",
    "vehicle": "Corresponde à patente do veículo utilizado. Aplica-se apenas a desvios que envolvam condução.",
    "accountable": "Fica a critério da (s) pessoa (s) responsável (is) pela gestão do desvio.",
    "manager": "Corresponde à pessoa que gerenciou o desvio.",
    "desvHelp1": "Corresponde ao status de gerenciamento de desvio.",
    "desvCat1Label": "Abrir:",
    "desvCat2Label": "Fechado na hora:",
    "desvCat3Label": "Fechado expirou:",
    "desvCat4Label": "Vencido:",
    "desvCat5Label": "Cancelado:",
    "desvCat6Label": "Notificações:",
    "desvCat1LabelDesc": "desvios que ainda não foram administrados, mas que estão dentro do prazo.",
    "desvCat2LabelDesc": "desvios que foram administrados dentro do prazo estabelecido.",
    "desvCat3LabelDesc": "desvios que foram administrados fora do período estabelecido.",
    "desvCat4LabelDesc": "desvios que ainda não foram administrados e cujo prazo já expirou.",
    "desvCat5LabelDesc": "desvios cujos eventos correspondiam a falsos positivos foram, portanto, cancelados do sistema pelo gestor.",
    "desvCat6LabelDesc": "desvios cujos eventos não requerem gestão."
  },
  "filters": {
    "type": "Tipo",
    "state": "Estado",
    "person": "Empregado",
    "vehicle": "Veículo",
    "accountable": "Responsável",
    "manager": "Gestão por",
    "geoZone": "Geozona",
    "all": "Todos",
    "stateOptions": {
      "": "Todos",
      "Abierta": "Aberta",
      "Cerrada": "Fechada",
      "Cerrada vencida": "Fechada vencida",
      "Vencida": "Vencida"
    },
    "annulTasks": "Anular tarefas",
    "show": "Mostrar",
    "subtype": "Subtipo",
    "workingShiftGroup": "Grupo de turno"
  },
  "states": {
    "CLOSED": "Fechado na hora:",
    "OPEN": "Abrir",
    "OVERDUE": "Em atraso",
    "CLOSEDOVERDUE": "Fechado expirado",
    "ANNULLED": "Cancelado",
    "NOTIFICATION": "Notificação",
    "PENDINGRECLASIFICATION": "Pendente de reclassificação"
  },
  "taskform": {
    "description": "Descrição",
    "taskCreationDate": "Data criação",
    "download": "Descarregar",
    "downloading": "Baixando",
    "downloadErrorMediaTitle": "Falhou o download",
    "downloadErrorMediaDescription": "Ocorreu um erro ao baixar o arquivo, tente novamente.",
    "fileNotUploaded": "Não subiu o arquivo",
    "save": "Fechar tarefa",
    "closed": "Tarefa fechada",
    "taskInformation": "Informação da tarefa",
    "taskManagement": "Gestão da tarefa",
    "dueDate": "Data vencimento",
    "eventDate": "Data evento",
    "taskCloseDate": "Data de fechamento",
    "taskClosed": "Tarefa fechada",
    "next": "Seguinte",
    "back": "Anterior",
    "plate": "Placa",
    "driver": "Condutor",
    "BREATHALYSER": "Alcoteste",
    "PVTTEST": "PVT",
    "FORM": "Pesquisa",
    "detail": "Detalhe",
    "loadingOptions": "Opções de carregamento.",
    "loadingOptionsError": "Falha ao carregar opções, recarregue a tarefa.",
    "loadingMedia": "Carregando arquivo",
    "loadingMediaError": "Falha ao carregar arquivo, recarregue a tarefa.",
    "actions": {
      "Reclassify": "Reclassificar",
      "Annul": "Cancelar",
      "Close": "Fechar",
      "Save": "Salvar"
    },
    "actionsResults": {
      "Reclassify": "Tarefa reclassificada",
      "Annul": "Tarefa abortada",
      "Close": "Tarefa fechada",
      "Save": "Salvar rascunho de tarefa"
    },
    "invalid": "Você deve preencher este campo para fechar o desvio.",
    "showDescription": "veja a descrição",
    "hideDescription": "esconder a descrição",
    "goBack": "De volta",
    "withoutDeviationInformation": "Nenhuma informação relacionada ao desvio foi encontrada."
  },
  "excel": {
    "downloadExcel": "Descarregar dados no arquivo Excel",
    "downloadSummaryExcel": "Descarregar dados resumidos",
    "downloadNoProcessExcel": "Descarregar dados sem processar",
    "downloadFileNameSummary": "dados_gerenciador_resumo",
    "downloadFileNameNoProcess": "dados_gerenciador_nao_tratados",
    "downloadErrorDateRangeTitle": "Período de download não permitido",
    "downloadErrorDateRangeDescription": "Você excedeu o período de download permitido (3 meses ou menos). Para solicitar um relatório abrangendo um período superior a 3 meses, entre em contato com o help desk da Gauss Control.",
    "downloadingTitle": "Baixando relatório",
    "downloadingPleaseWait": "Processando seu download, esta operação pode levar vários minutos..."
  },
  "feedback": {
    "maxToAnnulReached": "O número máximo de tarefas que podem ser selecionadas para abortar foi excedido.",
    "nothingSelectedToAnnul": "Você deve selecionar pelo menos uma tarefa para anular.",
    "annulSuccess": "Tarefas abortadas com sucesso",
    "annulError": "Ocorreu um erro ao tentar abortar as tarefas. Tente novamente.",
    "editSuccess": "Tarefa modificada com sucesso",
    "editError": "Ocorreu um erro ao tentar modificar a tarefa. Tente novamente."
  },
  "annulConfirm": {
    "confirmButton": "Sim",
    "cancelButton": "Não",
    "question": "Tem certeza de que deseja cancelar esses desvios?",
    "warning": "Ao cancelar um desvio não será mais possível aplicar a gestão correspondente.",
    "questionSingle": "Tem certeza de que deseja cancelar este desvio?",
    "warningSingle": "Ao cancelar um desvio não será mais possível aplicar a gestão correspondente."
  },
  "topCharts": {
    "tasksByState": "Distribuição de tarefas por estado",
    "totalTasks": "Total",
    "manageTasks": "Tarefas de gestão",
    "notifications": "Notificações"
  },
  "driverErrorAlert": {
    "confirmButton": "Entendido!",
    "title": "De acordo com o sistema este desvio corresponde a outro funcionário",
    "line1a": "Foi identificado que este desvio pertenece ao funcionário",
    "line1b": ", na qual não corresponde com a seleção de funcionário realizada.",
    "line2": "O sistema Gauss Control atribuiu de forma previa o funcionário no qual pertence este desvio. Obrigado, a informação obtida de diferentes fontes de dados é possível identificar e atribuir de forma automática às pessoas correspondentes.",
    "line3": "Atualize a plataforma para restabelecer a informação."
  },
  "tab": {
    "not_tabs_assigned": "Nenhuma guia atribuída",
    "tasks": "Desvios",
    "notifications": "Notificações",
    "detail": "Detalhe"
  },
  "redirectDetail": {
    "sessionExpiredTitle": "Sessão expirada",
    "sessionExpiredMessage": "Abra o link que fornecemos novamente para fazer login e acessar sua conta."
  }
};


// WEBPACK FOOTER //
// ./source/client/components/locales/language_configuration/portuguese/task_manager/taskManager.js